import type { SchemaConditions } from 'cpool-schemas';
import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

type FormLiabilities = {
    [key in keyof SchemaLoanRequestResolver_Get['haushalt']['verbindlichkeiten']]: Array<
        (SchemaLoanRequestResolver_Get['haushalt']['verbindlichkeiten'][key] extends Array<infer T> ? T : never) & {
            hide?: boolean;
        }
    >;
};

export const prepareLiabilities = (
    liabilities: SchemaLoanRequestResolver_Get['haushalt']['verbindlichkeiten'],
    liabilityStates: SchemaConditions['liabilityStates'],
) =>
    Object.entries(liabilities).reduce((acc, [key, liabilityKind]) => {
        return {
            ...acc,
            [key]: (liabilityKind ?? []).map((liability) => {
                const liabilityState = liabilityStates?.find((state) => state.id === liability.id);
                return {
                    ...liability,
                    hide: liabilityState?.hide ?? false,
                };
            }),
        };
    }, {} as FormLiabilities);
